import { rankingData } from '@/mocks/home';

export default function RankingSection() {
  const getRankStyle = (rank: number) => {
    if (rank === 1) return 'bg-primary-500 text-white';
    if (rank === 2) return 'bg-primary-400 text-white';
    if (rank === 3) return 'bg-accent-500 text-white';
    return 'bg-background-200 text-foreground-600';
  };

  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">吃瓜榜单</h2>
          <p className="text-foreground-600 text-sm md:text-base">实时热度排行榜</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="rounded-xl overflow-hidden border border-background-200/70 bg-background-50">
            {rankingData.map((item, idx) => (
              <div
                key={item.rank}
                className={`flex items-center gap-4 p-4 md:p-5 hover:bg-background-100 transition-colors cursor-pointer ${
                  idx < rankingData.length - 1 ? 'border-b border-background-200/50' : ''
                }`}
              >
                <span className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${getRankStyle(item.rank)}`}>
                  {item.rank}
                </span>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 truncate">{item.title}</h3>
                </div>
                <div className="flex items-center gap-2 flex-shrink-0">
                  {item.trend === 'up' && (
                    <span className="w-5 h-5 flex items-center justify-center rounded bg-secondary-100 text-secondary-600">
                      <i className="ri-arrow-up-line text-xs"></i>
                    </span>
                  )}
                  {item.trend === 'new' && (
                    <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold">NEW</span>
                  )}
                  <span className="text-xs md:text-sm font-semibold text-primary-600 whitespace-nowrap">{item.heat}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}